import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private navCtrl: NavController
  ) { }

  canActivate(next: ActivatedRouteSnapshot): boolean {
    const token = localStorage.getItem('token');
    if (token) {
      return true;
    }
    this.navCtrl.navigateRoot('/auth');
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(
    private navCtrl: NavController
  ) { }

  canActivate(): boolean {
    const token = localStorage.getItem('token');
    if (token) {
      this.navCtrl.navigateRoot('/');
      return false;
    }
    return true;
  }
}